module.exports = __webpack_public_path__ + "static/media/sudaneze-orgs.f8815d42.svg";